import { sessionSchema } from "schemas";
import { z } from "zod";
import { apiClient } from "../client";

export const getCustomerSessions = async (customerId: string) =>
  z
    .object({ sessions: z.array(sessionSchema) })
    .parse((await apiClient.get(`v2/customers/${customerId}/sessions`)).data).sessions;
